@if (isLoading) {
  <div class="flex justify-center">
    @if (isLoading) {
      <p-progressSpinner></p-progressSpinner>
    }
  </div>
}
@if (!isLoading) {
  <div>
    <div class="flex items-center gap-4 mb-4">
      <button
        type="button"
        pButton
        icon="pi pi-arrow-left"
        [rounded]="true"
        [text]="true"
        (click)="goBack()"
      >
      </button>
      <div>
        <p class="font-bold">{{ user?.firstName }} {{ user?.lastName }}</p>
        <p [class]="{ 'text-red-400': !user?.isActive }">
          {{ user?.isActive ? 'Active User' : 'Inactive User' }}
        </p>
      </div>
      <!-- <div class="ml-4"> -->
      <button
        type="button"
        pButton
        class="ml-4"
        label="{{ !user?.isActive ? 'Activate User' : 'Deactivate User' }}"
        [appChangeUserStatus]="user"
        [accessEnableSubmit]="['ExternalUser.Write']"
        [disabled]="!isButtonDisabled"
      >
        <i class="pi pi-power-off icon-color p-button-icon-left"></i>
      </button>
      <!-- </div> -->
      <div class="flex gap-2 ml-auto">
        @if (hasDevices) {
          <button type="button"
                  pButton
                  class="ml-auto p-button-outlined"
                  label="Reset MFA Device"
                  (click)="deleteDevices()">
            <i class="pi pi-refresh icon-color p-button-icon-left"></i>
          </button>
        }

        @if (isChangeUserEnabled) {
          <ng-container *accessView="['AdminPage.UI.Read']">
            <button
              pButton
              type="button"
              class="ml-auto p-button-outlined"
              label="Change User Type"
              (click)="changeUserType()"
            ></button>
          </ng-container>
        }
      </div>
    </div>
    <div class="mb-8">
      <p-table [value]="users"
               class="table-parameters table-simple-paginator"
               [alwaysShowPaginator]="false">
        <ng-template pTemplate="header">
          <tr>
            <th>Health Plan</th>
            <th>Account Type</th>
            <th>Created On / Modified On</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item>
          <tr>
            <td>{{ user?.healthPlans?.join(', ') }}</td>
            <td>{{ user?.accountType }}</td>
            <td>{{ dateTime | utcToLocal }}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
    @if (showWarningMessage) {
      <div class="mb-6 mt-0">
        <p-message class="w-128" severity="warn" icon="pi pi-exclamation-triangle">
          <p class="font-semibold text-xs">Unable to Modify Health Plan or Account Type</p>
          <p class="text-xs">This is an SSO account and changes cannot be made to this account.</p>
        </p-message>
      </div>
    }
    <div class="mb-4">
      <form [formGroup]="form">
        <div class="p-form-widget grid grid-cols-12 gap-4 p-fluid pl-2">
          <div class="col-span-4">
            <div class="flex items-center gap-2">
              <label class="field-required text-neutral-700">First Name:</label>
              <div class="grow">
                <input pInputText type="text" formControlName="givenName" class="w-full" maxlength="50" />
              </div>
            </div>
          </div>
          <div class="col-span-4">
            <div class="flex items-center gap-2">
              <label class="field-required text-neutral-700">Last Name:</label>
              <div class="grow">
                <input pInputText type="text" formControlName="surname" class="w-full" maxlength="50" />
              </div>
            </div>
          </div>
          <div class="col-span-4">
            <div class="flex items-top gap-2">
              <label class="text-neutral-700 shrink-0 py-2">Business Email:</label>
              <div class="grow">
                <input pInputText type="text" formControlName="otherMails" class="w-full" maxlength="50" />
                @if (showEmailWarningMessage) {
                  <div class="mb-6">
                    <p-message severity="warn" [motionOptions]="{ appear: false }" icon="pi pi-exclamation-triangle">
                      <span class="text-xs">Common Domain Email Address: Please verify that this is the user's business email account.</span>
                    </p-message>
                  </div>
                }
              </div>
            </div>
          </div>
          <div class="col-span-4 p-fluid">
            <div class="flex items-center gap-2">
              <label class="field-required text-neutral-700">Business Fax:</label>
              <div class="grow">
                <p-input-mask
                  mask="(999) 999-9999"
                  styleClass="w-full"
                  formControlName="facsimileTelephoneNumber"
                  [unmask]="true"
                  [autoClear]="false"
                />
              </div>
            </div>
          </div>
          <div class="col-span-4 fluid">
            <div class="flex items-center gap-2">
              <label class="field-required text-neutral-700">Business Phone:</label>
              <div class="grow">
                <p-input-mask
                  mask="(999) 999-9999"
                  styleClass="w-full"
                  formControlName="telephoneNumber"
                  [unmask]="true"
                  [autoClear]="false"
                />
              </div>
            </div>
          </div>
          <div class="col-span-4 fluid">
            <div class="flex items-center gap-2">
              <label class="text-neutral-700">Phone Number Extension:</label>
              <div class="grow">
                <input pInputText type="text" class="w-full" formControlName="telephoneNumberExtension" />
                @if (form?.controls['telephoneNumberExtension']?.hasError('maxlength')) {
                  <small class="p-error">
                    Must be up to 9 characters long
                  </small>
                }
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="flex justify-end">
      <ng-container *accessView="['ExternalUser.Write']">
        <button
          type="button"
          pButton
          severity="info"
          label="Cancel"
          (click)="onCancel()"
          class="mr-2"
          [disabled]="!form.dirty || !isFormChanged"
        ></button>
        <button
          type="submit"
          pButton label="Save"
          (click)="onSave()"
          class="p-button-action"
          [disabled]="canSaveUser"
        ></button>
      </ng-container>
    </div>
  </div>
}
<!-- <p-panel
*ngIf="!isLoading"
header="User Profile"
[showHeader]="false"
[toggleable]="true"
>

</p-panel> -->

<p-confirmDialog
  header="Confirmation"
  appendTo="body"
  [rejectIcon]="''"
  [acceptIcon]="''"
  [rejectButtonStyleClass]="'p-button-secondary'"
  [style]="{ width: '398px' }"
>
</p-confirmDialog>
<p-toast key="saved" position="bottom-left"></p-toast>

<p-confirmDialog
  key="unsavedChanges"
  appendTo="body"
  rejectIcon="''"
  acceptIcon="''"
  rejectButtonStyleClass="p-button-secondary"
  acceptButtonStyleClass="p-button-warning"
  [style]="{width: '398px'}"
></p-confirmDialog>

